import axiosInstance from './axiosConfig';

export const getTransactionsApi = (params) => axiosInstance.get('/financials', { params });
export const createTransactionApi = (payload) => axiosInstance.post('/financials', payload);
export const updateTransactionApi = (id, payload) => axiosInstance.put(`/financials/${id}`, payload);
export const getFinancialSummaryApi = (params) =>
  axiosInstance.get('/financials/summary', { params });
export const uploadReceiptApi = (id, file) => {
  const formData = new FormData();
  formData.append('receipt', file);
  return axiosInstance.post(`/financials/${id}/receipt`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};